import { Injectable } from '@angular/core';

import { LoaderState } from './loader';
import { Subject } from 'rxjs';

@Injectable({
   providedIn: 'root'
})
export class LoaderService {

   private loaderSubject = new Subject<LoaderState>();

   loaderState = this.loaderSubject.asObservable();

   static a = 1;
   count = 0;
   id = LoaderService.a++;
   constructor() {
      console.log('LoaderService')
   }

   show() {
      this.count++;
      this.loaderSubject.next(<LoaderState>{ show: true, count: this.count });
   }

   hide() {
      this.count--;
      this.loaderSubject.next(<LoaderState>{ show: false, count: this.count });
   }
}
